import { map } from "rxjs";
import { Account } from "../../model/BonusGame";
import { apiService } from "../ApiService";

export const getBonusGames = () => {
  return apiService
    .get<{ account: Account }>({
      path: `public/account/bonus_games`,
      requiresAuthPolicy: "user",
      crm: true,
    })
    .pipe(map(({ account }) => account));
};
